<template>
    <div>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-checkbox-group
                    name="Condição avaliada"
                    v-model="data.model.condicaoAvaliada"
                    :validations="validations.condicaoAvaliada"
                >
                    <rkm-form-checkbox
                        v-for="condicao in data.form.condicaoAvaliada"
                        :disabled="disableCondicao(condicao.id)"
                        :key="condicao.id"
                        :value="condicao.id"
                        class="w-25 m-0"
                    >
                        {{ condicao.descricao }}
                    </rkm-form-checkbox>
                </rkm-form-checkbox-group>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    no-margin-top
                    title="Doenças transmissíveis"
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-form-checkbox-group
                                name="Doenças transmissíveis"
                                v-model="data.model.doencaTransmissivel"
                                :validations="validations.doencaTransmissivel"
                            >
                                <rkm-form-checkbox
                                    v-for="doencao in data.form.doencaTransmissivel"
                                    :key="doencao.id"
                                    :value="doencao.id"
                                    class="w-25 m-0"
                                >
                                    {{ doencao.descricao }}
                                </rkm-form-checkbox>
                            </rkm-form-checkbox-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    no-margin-top
                    title="Rastreamentos"
                >
                    <rkm-row>
                        <rkm-col cols="12">
                            <rkm-form-checkbox-group
                                name="Rastreamento"
                                v-model="data.model.rastreamento"
                                :validations="validations.rastreamento"
                            >
                                <rkm-form-checkbox
                                    v-for="rastreamento in data.form.rastreamento"
                                    :disabled="disableRastreamento(rastreamento.id)"
                                    :key="rastreamento.id"
                                    :value="rastreamento.id"
                                    class="w-25 m-0"
                                >
                                    {{ rastreamento.descricao }}
                                </rkm-form-checkbox>
                            </rkm-form-checkbox-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-area
                    no-margin-top
                    title="Outros"
                >
                    <template
                        slot="trailing"
                    >
                        <rkm-button
                            @click="$refs.Modal.open()"
                            color="primary"
                            small
                            title="Adicionar"
                        >
                            <rkm-icon icon="plus" />
                        </rkm-button>
                    </template>

                    <rkm-row>
                        <rkm-col cols="12">
                            <List
                                :data="data"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import List from './List'
import Modal from './Modal'

// Enums.
import sexo from '@/enums/cadastro/cidadao/sexo'
import condicaoAvaliada from '@/enums/atencao-basica/atendimento-individual/condicaoAvaliada'
import rastreamento from '@/enums/atencao-basica/atendimento-individual/rastreamento'

export default {
    components: {
        List,
        Modal,
    },
    computed: {
        autocompleteRequestParams() {
            return {
                ciap1: {
                    sexo_id: this.data.model.cidadao.sexoId,
                    ciap_id: this.data.model.atendimento.ciap2 ? this.data.model.atendimento.ciap2.id : null,
                },
                ciap2: {
                    sexo_id: this.data.model.cidadao.sexoId,
                    ciap_id: this.data.model.atendimento.ciap1 ? this.data.model.atendimento.ciap1.id : null,
                },
                cid1: {
                    sexo: this.data.model.cidadao.sexoId
                        ? this.data.model.cidadao.sexoId == this.enums.sexo.MASCULINO ? 'M' : 'F'
                        : null,
                    cid_id: this.data.model.atendimento.cid2 ? this.data.model.atendimento.cid2.id : null,
                },
                cid2: {
                    sexo: this.data.model.cidadao.sexoId
                        ? this.data.model.cidadao.sexoId == this.enums.sexo.MASCULINO ? 'M' : 'F'
                        : null,
                    cid_id: this.data.model.atendimento.cid1 ? this.data.model.atendimento.cid1.id : null,
                },
            }
        },
        validations() {

            return {
                condicaoAvaliada: { required: this.disabledCondicaoAvaliada()},
                doencaTransmissivel: { required: this.disabledDoencaTransmissivel()},
                rastreamento: { required: this.disabledRastreamento()},
            }
        },
    },
    data: () => ({
        enums: {
            sexo,
            condicaoAvaliada,
            rastreamento,
        },
    }),
    methods: {
        disabledCondicaoAvaliada() {
            return this.data.model.doencaTransmissivel && this.data.model.doencaTransmissivel.length === 0
                && this.data.model.rastreamento && this.data.model.rastreamento.length === 0
                && this.data.model.problemasCondicoes && this.data.model.problemasCondicoes.length === 0 ? true : false
        },
        disabledDoencaTransmissivel() {
            return this.data.model.condicaoAvaliada && this.data.model.condicaoAvaliada.length === 0
                && this.data.model.rastreamento && this.data.model.rastreamento.length === 0
                && this.data.model.problemasCondicoes && this.data.model.problemasCondicoes.length === 0 ? true : false
        },
        disabledRastreamento() {
            return this.data.model.condicaoAvaliada && this.data.model.condicaoAvaliada.length === 0
                && this.data.model.doencaTransmissivel && this.data.model.doencaTransmissivel.length === 0
                && this.data.model.problemasCondicoes && this.data.model.problemasCondicoes.length === 0 ? true : false
        },
        disableCondicao(condicaoId) {

            return (condicaoId == this.enums.condicaoAvaliada.PRE_NATAL || condicaoId == this.enums.condicaoAvaliada.PUERPERIO)
                && this.data.model.cidadao.sexoId == this.enums.sexo.MASCULINO
        },
        disableRastreamento(rastreamentoId) {

            return rastreamentoId == this.enums.rastreamento.CANCER_COLO_UTERO
                && this.data.model.cidadao.sexoId == this.enums.sexo.MASCULINO
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>